import React from "react";
import { Input, Select, Button, Space, DatePicker, Row, Col, Dropdown, Checkbox, Modal, Tooltip } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { PlusOutlined, DownOutlined, EyeOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import moment from "moment";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import AiAlarmReportStore from "../store/AiAlarmReportStore";
import { a } from "react-spring";
const { RangePicker } = DatePicker;

dayjs.extend(customParseFormat);
const { Option } = Select;
class AiAlarmReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.AiAlarmReportStore = new AiAlarmReportStore();

    this.vehicleStore = new VehicleStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      selectedVehicles: [],
      selectAllVehicles: false,
      selectAllAlarms: false,
      modalVisible: false,
      column: "",
      filter: "",
      Notcompany: false,
      Notasset: false,
      Notalarm: false,
      evidenceVisible: false,
      selectedRecord: null,
      evidenceHowenVisible: false,
      showimg: false,
      modalContent: null,  // this will store image/video JSX
      selectedColumns: [
        {
          // title: 'Vehicle No ',
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: "15%",
        },
        {
          // title: 'Device Serial Id',
          title: context.translate("_DRIVER_NAME_"),
          dataIndex: "driverName",
          key: "driverName",
          width: "15%",
        },

        {
          // title: 'Date Time',
          title: context.translate("_ALARM_TYPE_"),
          dataIndex: "alarmName",
          key: "alarmName",
          width: "15%",
        },
        {
          // title: 'Latitude',
          title: context.translate("_LOCATION_TIME_"),
          dataIndex: "timestamp",
          key: "timestamp",
          width: "15%",
        },
        {
          // title: 'Longitude',
          title: context.translate("_START_TIME_"),
          dataIndex: "st",
          key: "st",
          width: "15%",
        },
        {
          // title: 'Speed',
          title: context.translate("_END_TIME_"),
          dataIndex: "et",
          key: "et",
          width: "15%",
        },
        {
          // title: 'Alarm Type',
          title: context.translate("_LOCATION_"),
          dataIndex: "location",
          key: "location",
          width: "15%",
          /*
          renderer: function (value) {
                    if (!value || value == "") {
                        return "NA";
                    }
                    return '<div><a href="javascript:void(0);">' + value + '</a></div>'
                },
                listeners: {
                    scope: this,
                    click: function (view, cell, cellIndex, ee, row, record, e) {
                        if (cell.innerText.trim() != "NA") {
                            this.drawRouteByGeoComplete(record.get('latitude'), record.get('longitude'));
                        }
                    }
                }
          */
        },
        {
          // title: 'Content',
          title: context.translate("_SPEED_"),
          dataIndex: "speed",
          key: "speed",
          width: "15%",
        },
        {
          // title: 'Command Type',
          title: context.translate("_DETAILS_"),
          dataIndex: "alarmString",
          key: "alarmString",
          width: "15%",
        },
        {
          title: context.translate("_ACTION_"),
          dataIndex: "Action",
          width: "9%",
          align: "center",
          render: (_, record) => {
            return (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Tooltip title="View">
                  <EyeOutlined
                    style={{ cursor: "pointer", fontSize: "16px", color: "#1890ff" }}
                    onClick={() => {
                      // if (record.MDVR == "H-Protocol") {
                      //   this.showEvidence(record)
                      // } else {
                      //   this.getDevices(record);
                      // }
                      if (record.MDVR == "H-Protocol") {
                        // this.showEvidence(record);
                        this.setState({
                          selectedRecord: record,

                        });
                        this.showHowenEvidence(record);
                      } else {
                        this.getEvidence(record);
                      }
                    }
                    }
                  />
                </Tooltip>
              </div>
            );
          },
        }
      ],
    };
    this.mediaCount = 0;
    this.menuProps = {
      items: [
        {
          // label: "Excel",
          label: context.translate("_EXCEL_"),
          key: "excel",
          icon: <PlusOutlined />,
        },
        {
          // label: "PDF",
          label: context.translate("_PDF_"),
          key: "pdf",
          icon: <PlusOutlined />,
        },
      ],
      onClick: (val) => {
        let result = [];
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            alarmId: this.state.selectedAlarms,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
          };
          console.log(getData);
          if (val.key == "excel") {
            // console.log("afd")
            this.AiAlarmReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.AiAlarmReportStore.exportpdf(getData);
          }

        }



      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  showHowenEvidence = (record) => {
    console.log("evidence", record)
    this.setState({
      selectedRecord: record,
      evidenceHowenVisible: true
    });
  };

  showEvidence = (rec) => {
    const hasChannelData =
      rec?.chl1 === 1 || rec?.chl2 === 2 || rec?.chl3 === 3 || rec?.chl4 === 1;

    if (!hasChannelData) {
      Modal.warning({
        title: this.context.translate("_FLEET_ALERT_"),
        content: this.context.translate("_NO_DATA_"),
        style: {
          padding: "20px",
          borderRadius: "10px",
        },
      });
      return;
    }

    this.setState({
      selectedRecord: rec,
      evidenceVisible: true,
    });
  };
  handleCloseEvidence = () => {
    this.setState({
      evidenceVisible: false,
      selectedRecord: null,
    });
  };
  renderEvidenceContent = () => {
    console.log("render Evidence content");
    const { selectedRecord: rec } = this.state;
    if (!rec) return { content: null, mediaCount: 0 };

    const items = [];
    let mediaCount = 0;

    if (rec.chl1 === 1 || rec.chl2 === 2 || rec.chl3 === 3 || rec.chl4 === 4) {
      items.push(
        <div className="alert-info-block" key="info" style={{ marginBottom: 20 }}>
          <p><b>Vehicle No :</b> {rec.vehicleNo}</p>
          <p><b>Start Time :</b> {rec.st}</p>
          <p><b>End Time :</b> {rec.et}</p>
        </div>
      );

      let rowItems = [];
      let rowIndex = 0;
      let lastChannelIndex = null;
      for (let i = 1; i <= 4; i++) {
        const hasVideo = rec[`chl${i}`];
        const hasImage = rec[`chl${i}-snap`];
        const session = rec.sessionNo;
        var videoUrl = "";
        var imageUrl = "";
        // if (features.showUrl) {
        videoUrl = `https://media.trackeazy.com/howendownloaded/test/multimedia#${session}-${i}`;
        imageUrl = `https://media.trackeazy.com/howendownloaded/image/${session}-${i}-snap`;
        // }


        console.log("hasImage", hasImage)
        if (hasImage) {
          mediaCount++;
          lastChannelIndex = i; // Update
          rowItems.push(
            <div key={`img-${i}`} style={{ width: 500, marginLeft: '16px' }}>
              <div style={{ fontWeight: "bold", marginBottom: 5 }}>Image - Channel {i}</div>
              <img
                src={imageUrl}
                alt={`Channel ${i} Image`}
                width={350}
                height={360}
                style={{
                  objectFit: "cover",
                  border: "1px solid #ccc",
                  display: "block"
                }}
              />
            </div>
          );
        }
        console.log("hasImage", hasVideo)

        if (hasVideo) {
          console.log("object", videoUrl)
          mediaCount++;
          lastChannelIndex = i; // Update
          rowItems.push(
            <div key={`vid-${i}`} style={{ width: 500, marginLeft: '16px' }}>
              <div style={{ fontWeight: "bold", marginBottom: 5 }}>Video - Channel {i}</div>
              <iframe
                src={videoUrl}
                width={350}
                height={360}
                frameBorder="0"
                allowFullScreen
                style={{
                  border: "1px solid #ccc",
                  display: "block"
                }}
              />
            </div>
          );
        }
        console.log("hfghr", rowItems.length)
        if (rowItems.length >= 2) {
          items.push(
            <div
              key={`row-${rowIndex++}`}
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                marginBottom: "20px"
              }}
            >
              {rowItems}
            </div>
          );
          rowItems = [];
        }
      }
      console.log("skjfghrg", rowItems.length)

      if (rowItems.length > 0) {
        items.push(
          <div
            key={`row-${rowIndex++}`}
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              marginBottom: "20px"
            }}
          >
            {rowItems}
          </div>
        );
      }


      console.log("Last Channel Index with media:", lastChannelIndex);

    } else {
      items.push(
        <div className="alert-info-block" key="nodata" style={{ marginBottom: 20 }}>
          <p>No Data</p>
        </div>
      );
    }
    console.log("********************************", items)

    return {
      content: <div style={{ width: "100%", margin: 0, padding: 0 }}>{items}</div>,
      mediaCount
    };
  };
  async componentDidMount() {
    console.log("AI ALARM REPORT LIST");
    this.setState({ pageSize: 50 });


    await this.setState({ column: this.state.selectedColumns });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }
  setStateAsync(update) {
    return new Promise((resolve) => this.setState(update, resolve));
  }
  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    await this.AiAlarmReportStore.getAlarms();
    var alarmId = this.context.viewStateStore.aiDashboardObject.alarmId;
    const rawFromDate = this.context.viewStateStore.aiDashboardObject.fromDate; // "2025-07-20"
    const rawToDate = this.context.viewStateStore.aiDashboardObject.toDate;     // "2025-07-26"

    const fromDate = dayjs(rawFromDate);
    const toDate = dayjs(rawToDate);

    // // Optional checks
    // if (!fromDate.isValid() || !toDate.isValid()) {
    //   console.error("Invalid date(s) from context");
    //   return;
    // }

    // if (fromDate.isAfter(toDate)) {
    //   console.warn(" From date is after To date!");
    //   return;
    // }

    if (alarmId > 1) {
      console.log("From Dashboard")
      await this.setStateAsync({ selectAllVehicles: true, selectedAlarms: alarmId, fromDate: fromDate, toDate: toDate });
      console.log(this.state.selectAllVehicles, fromDate, toDate);
      await this.handleAllSelectVehicles();


      await this.AiAlarmReportStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        vehicleId: this.state.selectedVehicles,
        alarmId: this.state.selectedAlarms,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
      });
      this.setState({ listUpdated: 1 });

    } else {
      await this.setState({ selectedVehicles: [], selectAllVehicles: false });
    }
    await this.setState({ currentPage: 1, companyId: comp?.value });



    this.handleSearch();
  }


  async handleSearch() {
    this.setState({ Notasset: false });
    this.setState({ Notalarm: false, loading: true });
    // await this.AiAlarmReportStore.loadData({
    //   offset: (this.state.currentPage - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: this.state.companyId,
    //   vehicleId: this.state.selectedVehicles,
    //   alarmId: this.state.selectedAlarms,
    //   fromDate: this.state.fromDate,
    //   toDate: this.state.toDate,
    // });

    await this.setState({ listUpdated: 1, loading: false }); //need to reload data
  }
  onDateTimeChange = (dates) => {
    console.log(dates);
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        // fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }

  };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.selectedAlarms.length === 0) {
      this.setState({ Notalarm: true });
    } else {
      this.setState({ Notalarm: false });
    }
    if (this.state.companyId && this.state.selectedVehicles.length > 0) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false, Notalarm: false });
      await this.AiAlarmReportStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
        vehicleId: this.state.selectedVehicles,
        alarmId: this.state.selectedAlarms,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
      });
      this.setState({ listUpdated: 1 });
      // console.log(this.state.fromDate,this.state.toDate,)
    }
  };
  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };
  handleAllSelectAlarms = async (e) => {
    if (this.state.selectAllAlarms) {
      const allAlarms = this.AiAlarmReportStore?.alarmlist.map(
        (val) => {
          return val.alarmId;
        }
      );
      await this.setState({ selectedAlarms: allAlarms });
    } else {
      await this.setState({ selectedAlarms: [] });
    }
  };
  handleCheckboxChange = async (column) => {
    // console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      // console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  // showEvidence = (rec) => {

  //   const hasChannelData =
  //     rec?.chl1 === 1 || rec?.chl2 === 1 || rec?.chl3 === 1 || rec?.chl4 === 1;

  //   if (!hasChannelData) {
  //     Modal.warning({
  //       title: this.context.translate("_FLEET_ALERT_"),
  //       content: this.context.translate("_NO_DATA_"),
  //       style: {
  //         padding: "20px",
  //         borderRadius: "10px",
  //       },
  //     });
  //     return;
  //   }


  //   this.setState({
  //     selectedRecord: rec,
  //     evidenceVisible: true,
  //   });

  // }
  // handleCloseEvidence = () => {
  //   this.setState({
  //     evidenceVisible: false,
  //     selectedRecord: null,
  //   });
  // };

  // renderEvidenceContent = () => {
  //   const { selectedRecord: rec } = this.state;
  //   if (!rec) return { content: null, mediaCount: 0 };

  //   const items = [];
  //   let mediaCount = 0;

  //   if (rec.chl1 === 1 || rec.chl2 === 2 || rec.chl3 === 3 || rec.chl4 === 4) {
  //     items.push(
  //       <div className="alert-info-block" key="info" style={{ marginBottom: 20 }}>
  //         <p><b>Vehicle No :</b> {rec.vehicleNo}</p>
  //         <p><b>Start Time :</b> {rec.st}</p>
  //         <p><b>End Time :</b> {rec.et}</p>
  //       </div>
  //     );

  //     let rowItems = [];
  //     let rowIndex = 0;
  //     let lastChannelIndex = null;
  //     for (let i = 1; i <= 4; i++) {
  //       const hasVideo = rec[`chl${i}`];
  //       const hasImage = rec[`chl${i}-snap`];
  //       const session = rec.sessionNo;

  //       const videoUrl = `https://media.trackeazy.com/howendownloaded/test/multimedia#${session}-${i}`;
  //       const imageUrl = `https://media.trackeazy.com/howendownloaded/image/${session}-${i}-snap`;

  //       if (hasImage) {
  //         mediaCount++;
  //         lastChannelIndex = i; // Update
  //         rowItems.push(
  //           <div key={`img-${i}`} style={{ width: 500, marginLeft: '16px' }}>
  //             <div style={{ fontWeight: "bold", marginBottom: 5 }}>Image - Channel {i}</div>
  //             <img
  //               src={imageUrl}
  //               alt={`Channel ${i} Image`}
  //               width={350}
  //               height={360}
  //               style={{
  //                 objectFit: "cover",
  //                 border: "1px solid #ccc",
  //                 display: "block"
  //               }}
  //             />
  //           </div>
  //         );
  //       }

  //       if (hasVideo) {
  //         mediaCount++;
  //         lastChannelIndex = i; // Update
  //         rowItems.push(
  //           <div key={`vid-${i}`} style={{ width: 500, marginLeft: '16px' }}>
  //             <div style={{ fontWeight: "bold", marginBottom: 5 }}>Video - Channel {i}</div>
  //             <iframe
  //               src={videoUrl}
  //               width={350}
  //               height={360}
  //               frameBorder="0"
  //               allowFullScreen
  //               style={{
  //                 border: "1px solid #ccc",
  //                 display: "block"
  //               }}
  //             />
  //           </div>
  //         );
  //       }

  //       if (rowItems.length >= 2) {
  //         items.push(
  //           <div
  //             key={`row-${rowIndex++}`}
  //             style={{
  //               display: "flex",
  //               flexDirection: "row",
  //               gap: "20px",
  //               marginBottom: "20px"
  //             }}
  //           >
  //             {rowItems}
  //           </div>
  //         );
  //         rowItems = [];
  //       }
  //     }

  //     if (rowItems.length > 0) {
  //       items.push(
  //         <div
  //           key={`row-${rowIndex++}`}
  //           style={{
  //             display: "flex",
  //             flexDirection: "row",
  //             gap: "20px",
  //             marginBottom: "20px"
  //           }}
  //         >
  //           {rowItems}
  //         </div>
  //       );
  //     }


  //     // console.log("Last Channel Index with media:", lastChannelIndex);

  //   } else {
  //     items.push(
  //       <div className="alert-info-block" key="nodata" style={{ marginBottom: 20 }}>
  //         <p>No Data</p>
  //       </div>
  //     );
  //   }

  //   return {
  //     content: <div style={{ width: "100%", margin: 0, padding: 0 }}>{items}</div>,
  //     mediaCount
  //   };
  // };





  getDevices = async (rec) => {
    const data = { vehicleId: rec.vehicleId, companyId: rec.companyId };
    const response = await this.AiAlarmReportStore.getDevices(data);
    // console.log(response)
    if (response.success == "S") {
      this.setState({ selectedRecord: rec }); // Store record for modal title
      this.getImage(rec, response.data.data[0]);
    }
  };
  getImage = async (rec, device) => {
    const postData = [{
      token: device.token,
      conditionName: device.full_imei,
      startTime: rec.data.st,
      alarmName: rec.get("alarmName"),
      alarmTypeId: rec.get("alarmTypeId"),
      endTime: rec.data.et,
    }];

    const res = await this.AiAlarmReportStore.getAIdata(postData);
    if (res.success === "S" && res.data.length > 0) {
      const items2 = [];

      items2.push(
        <div className="alert-info-block" key="info" style={{ marginBottom: 20 }}>
          <p><b>Driver Name :</b> {rec.driverName}</p>
          <p><b>Vehicle No :</b> {rec.vehicleNo}</p>
          <p><b>Start Time :</b> {rec.st}</p>
          <p><b>End Time :</b> {rec.et}</p>
        </div>
      );

      for (let i = 0; i < res.data[0].alarmFile.length; i++) {
        const file = res.data[0].alarmFile[i];

        const baseUrl = device.cmsvssWebHost + (device.LoginServerPort ? `:${device.LoginServerPort}` : "");
        const fileUrl = `${baseUrl}/record/showImage.action?token=${device.token}&scheme=http&fileName=${file.fileThumbnail.replace(" ", "%20")}&deviceID=${device.full_imei}&fileSize=123456&fileType=2`;

        let videoUrl = file.downUrl.replace(/:\d+/, '');

        if (file.fileType == 2) {
          // Video
          items2.push(
            <div key={fileUrl} className="alert-video-block" style={{ width: 400, height: 360, marginBottom: 20 }}>
              <video width="370" height="360" controls>
                <source src={videoUrl} type="video/mp4" />
              </video>
              <div style={{ textAlign: "right", marginTop: 8 }}>
                <button
                  className="blue-download-btn icon-download"
                  onClick={() => window.location.href = videoUrl}
                >
                  Download
                </button>
              </div>
            </div>
          );
        } else {
          // Image
          items2.push(
            <div key={fileUrl}>
              <img
                src={fileUrl}
                width={370}
                height={360}
                style={{ margin: '0 0 20px 0' }}
                alt="Alert"
              />
              <div style={{ textAlign: "right", marginTop: 8 }}>
                <button
                  className="blue-download-btn icon-download"
                  onClick={() => window.location.href = videoUrl}
                >
                  Download
                </button>
              </div>
            </div>
          );
        }
      }

      this.setState({ modalContent: items2, showimg: true });
    }
  };
  renderHowenMedia = () => {

    console.log("object", this.state.selectedRecord)
    const rec = this.state.selectedRecord;
    // if (!rec) return null;

    let videoUrl = "";
    let imageUrl = "";
    let keyId = "";
    // if (features.showUrl) {
    keyId = rec?.sessionNo;
    imageUrl = rec?.filename;//`https://samedia.trackeazy.com/howendownloaded/test/multimedia#${rec?.sessionNo}-snap`;

    videoUrl = rec?.vdofilename;//`https://samedia.trackeazy.com/howendownloaded/test/multimedia#${rec?.sessionNo}-video`;
    // }

    return (
      <>
        <div className="alert-info-block" key="info" style={{ marginBottom: 20 }}>
          <p><b>Vehicle No :</b> {rec?.vehicleNo}</p>
          <p><b>Alarm Type:</b> {rec?.alarmName}</p>
          <p><b>Start Time :</b> {rec?.st}</p>
          <p><b>End Time :</b> {rec?.et}</p>
        </div>
        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "nowrap",
            alignItems: "flex-start"
          }}
        >
          {/* Image */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: "bold", marginBottom: 8 }}>Image</div>

            <img
              key={keyId}
              src={imageUrl}
              alt="Alert"
              style={{
                width: "100%",
                height: "360px",
                objectFit: "contain"
              }}

              onLoad={(e) => {
                e.currentTarget.style.display = "block";

                const parent = e.currentTarget.parentNode;
                const msg = parent.querySelector(".img-error-msg");

                if (msg) {
                  msg.remove();
                }
              }}
              onError={(e) => {
                e.currentTarget.style.display = "none";

                const parent = e.currentTarget.parentNode;

                if (!parent.querySelector(".img-error-msg")) {
                  const msg = document.createElement("div");
                  msg.className = "img-error-msg";
                  msg.style.padding = "20px";
                  msg.style.textAlign = "center";
                  msg.innerText = "Image not available";

                  parent.appendChild(msg);
                }
              }}
            />


          </div>

          {/* Video */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: "bold", marginBottom: 8 }}>Video</div>

            <video
              key={keyId}
              controls
              autoPlay
              muted
              playsInline
              style={{
                width: "100%",
                height: "360px",
                objectFit: "contain"
              }}
              onLoadedData={(e) => {
                e.currentTarget.style.display = "block";

                const parent = e.currentTarget.parentNode;
                const msg = parent.querySelector(".vdo-error-msg");

                if (msg) {
                  msg.remove();
                }
              }}
              onError={(e) => {
                e.currentTarget.style.display = "none";

                const parent = e.currentTarget.parentNode;

                if (!parent.querySelector(".vdo-error-msg")) {
                  const msg = document.createElement("div");
                  msg.className = "vdo-error-msg";
                  msg.style.padding = "20px";
                  msg.style.textAlign = "center";
                  msg.innerText = "Video not available";

                  parent.appendChild(msg);
                }
              }}

            >
              <source src={videoUrl} type="video/mp4" />
            </video>


          </div>
        </div >
      </>

    );
  };

  render() {

    const veh = "test";
    const rec = this.state.selectedRecord;


    const hasChannelData =
      rec && (rec.chl1 === 1 || rec.chl2 === 1 || rec.chl3 === 1 || rec.chl4 === 1);
    const { content, mediaCount } = this.renderEvidenceContent();


    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_AI_ALARM_REPORT_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >


                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {/* Columns */}
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.AiAlarmReportStore?.alarmData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button
                    //  style={{ backgroundColor: config.activeColor }}
                    className="exportDropdown"
                  >
                    <Space>
                      {/* Export */}
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          <Row className="listInputRow">
            <Space>
              <Col span={16}>
                <CompanyAutocomplete
                  allowClear={true}
                  onChange={(value) => this.handleChange(value)}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
              </Col>

              <Checkbox
                checked={this.state.selectAllVehicles}
                onChange={async (e) => {
                  await this.setState({ selectAllVehicles: e.target.checked });
                  if (this.state.selectAllVehicles) {
                    await this.setState({
                      Notasset: false,
                    });
                  }
                  // console.log(e.target.checked);
                  await this.handleAllSelectVehicles();
                }}
              />
              {/* All */}
              {this.context.translate("_ALL_")}
              {"  "}

              <Select
                maxTagCount="responsive"
                value={this.state.selectedVehicles}
                onChange={(val) => {
                  this.setState({ selectedVehicles: val });
                  if (
                    this.vehicleStore?.getVehiclesUsingCompanyId.length >
                    val.length
                  ) {
                    this.setState({ selectAllVehicles: false });
                  } else {
                    this.setState({ selectAllVehicles: true });
                  }

                  if (val?.length > 1) {
                    // console.log(val?.length > 1);
                    this.setState({ showAlertPopup: true });
                  }
                }}
                style={{ width: 200 }}
                showSearch
                status={this.state.Notasset ? "error" : false}
                mode="multiple"
                placeholder={this.context.translate(
                  "_VEHICLE_NO_"
                )}
                filterOption={(inputValue, option) => {
                  if (option.children) {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) >= 0
                    );
                  }
                }}
              >
                {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                  return <Option value={val.vehicleId}>{val.vehicleNo}</Option>;
                })}
              </Select>

              {/*alarm type combo*/}

              <Checkbox
                checked={this.state.selectAllAlarms}
                onChange={async (e) => {
                  await this.setState({ selectAllAlarms: e.target.checked });
                  if (this.state.selectAllAlarms) {
                    await this.setState({
                      Notalarm: false,
                    });
                  }
                  // console.log(e.target.checked);
                  await this.handleAllSelectAlarms();
                }}
              />
              {/* All */}
              {this.context.translate("_ALL_")}
              {"  "}

              <Select
                maxTagCount="responsive"
                value={this.state.selectedAlarms}
                onChange={(val) => {
                  this.setState({ selectedAlarms: val });
                  if (
                    this.AiAlarmReportStore?.alarmlist.length >
                    val.length
                  ) {
                    this.setState({ selectAllAlarms: false });
                  } else {
                    this.setState({ selectAllAlarms: true });
                  }

                  if (val?.length > 1) {
                    // console.log(val?.length > 1);
                    this.setState({ showAlertPopup: true });
                  }
                }}
                style={{ width: 200 }}
                showSearch
                status={this.state.Notalarm ? "error" : false}
                mode="multiple"
                placeholder={this.context.translate(
                  "_ALARM_TYPE_"
                )}
                filterOption={(inputValue, option) => {
                  if (option.children) {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) >= 0
                    );
                  }
                }}
              >
                {this.AiAlarmReportStore?.alarmlist?.map((val) => {
                  return <Option value={val.alarmId}>{val.alarmName}</Option>;
                })}
              </Select>


              <Col>

                <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400 }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />
              </Col>

              <Col>
                <Button type="primary" onClick={() => this.showData()}>
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                  {/* Show */}
                </Button>
              </Col>
            </Space>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={250}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {/* {console.log(this.newColumns, "Df")} */}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.AiAlarmReportStore?.total}
            columns={this.state.column}
            dataSource={this.AiAlarmReportStore?.alarmData}
            loading={this.AiAlarmReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          title={
            hasChannelData
              ? `Alert Name: ${this.state.selectedRecord?.alarmName || ""}`
              : "Alert"
          }
          open={this.state.evidenceVisible}
          onCancel={this.handleCloseEvidence}
          footer={null}
          width={mediaCount === 1 ? 450 : hasChannelData ? 850 : 200}
          bodyStyle={{ maxHeight: 600, overflowY: "auto", padding: 10 }}
          destroyOnClose
        >
          {content}
        </Modal>

        <Modal
          title={`Alert Name: ${this.state.selectedRecord?.alarmName || ""}`}
          open={this.state.showimg}
          onCancel={() => this.setState({ showimg: false })}
          footer={null}
          width={800}
          bodyStyle={{ maxHeight: 500, overflowY: "auto", padding: 10 }}
        >
          {this.state.modalContent}
        </Modal>

        <Modal
          title="Evidence Preview"
          open={this.state.evidenceHowenVisible}
          onCancel={() => this.setState({ evidenceHowenVisible: false })}
          footer={null}
          width={800}
          height={600}
          bodyStyle={{ maxHeight: "700px", overflowY: "auto" }}
        >
          {this.renderHowenMedia()}
        </Modal>

      </>
    );
  }
}
AiAlarmReport.contextType = StoreContext;
export default observer(withRouter(AiAlarmReport));
